import { render, staticRenderFns } from "./MigrationProceed.vue?vue&type=template&id=ebf52c56&"
import script from "./MigrationProceed.vue?vue&type=script&lang=js&"
export * from "./MigrationProceed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports